var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitcaseIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 3.58018H9.8V2.1065C9.8 1.2886 9.177 0.632812 8.4 0.632812H5.6C4.823 0.632812 4.2 1.2886 4.2 2.1065V3.58018H1.4C0.623 3.58018 0.00699999 4.23597 0.00699999 5.05386L0 13.1591C0 13.977 0.623 14.6328 1.4 14.6328H12.6C13.377 14.6328 14 13.977 14 13.1591V5.05386C14 4.23597 13.377 3.58018 12.6 3.58018ZM8.4 3.58018H5.6V2.1065H8.4V3.58018Z",
    fill: "#103A5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseIconBlue);
export default __webpack_public_path__ + "static/media/suitcase-icon-blue.36ea98d39fa8e3f8b4a80a27d22743ba.svg";
export { ForwardRef as ReactComponent };